import { createStyles, rem } from '@mantine/core'

type StylesParams = {
  isPink?: boolean
}

export default createStyles((theme, { isPink }: StylesParams) => {
  return {
    root: {
      backgroundColor: isPink ? theme.colors.pink[1] : theme.colors.blue[1],
      [theme.fn.smallerThan('sm')]: {
        overflow: 'hidden',
      },
    },
    inner: {
      padding: `${rem(8)} 0`,
      [theme.fn.largerThan('sm')]: { padding: `${rem(12)} 0 ${rem(24)}` },
      [theme.fn.smallerThan('sm')]: {
        paddingBottom: rem(12),
      },
    },
    thumbnailCol: {
      position: 'absolute',
      [theme.fn.largerThan('sm')]: {
        right: 0,
        top: '50%',
        transform: `translateY(-50%)`,
      },
      [theme.fn.smallerThan('sm')]: {
        right: 16,
        bottom: 10,
      },
    },
    thumbnail: {},
    thumbnailWrapper: {},
    thumbnailInner: {},
    medicalReview: {
      position: 'relative',
      minHeight: 48,
      [theme.fn.smallerThan('sm')]: {
        '&[data-icon="true"]': {
          paddingRight: 90,
        },
      },
    },
  }
})
